import * as React from 'react';
import { useState } from 'react';

import { GroupOption } from '@opendoor/bricks/core/Input';
import {
  PresentationalCheckboxGroup,
  PresentationalCheckboxGroupProps,
} from '@opendoor/bricks/core/Input/Checkbox';

export type CheckboxRadioProps = GroupOption & {
  onChange?: React.ChangeEventHandler;
};

type CheckboxGroupProps = Omit<
  PresentationalCheckboxGroupProps,
  'options' | 'name' | 'analyticsName'
> & {
  id: string;
  options: Array<CheckboxRadioProps>;
  noneOfTheAboveValue?: string;
  ariaLabelledBy?: string;
};

/**
 * This is a small wrapper around PresentationalCheckboxGroup to handle a `none
 * of the above` option
 */
export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  options,
  selectedValues = [],
  onClick,
  noneOfTheAboveValue,
  disabled,
  hasContainer,
  id,
  ariaLabelledBy,
}) => {
  const [checkedValues, setCheckedValues] = useState<Array<string>>(selectedValues ?? []);
  const handleClick = (value: string) => {
    if (noneOfTheAboveValue === value || checkedValues.includes(noneOfTheAboveValue || '')) {
      setCheckedValues(checkedValues.includes(value) ? [] : [value]);
    } else {
      setCheckedValues(
        checkedValues.includes(value)
          ? checkedValues.filter((val) => val !== value)
          : [...checkedValues, value],
      );
    }
    onClick(value);
  };

  return (
    <PresentationalCheckboxGroup
      analyticsName={`reception-fe-question-${id}`}
      name={id}
      aria-labelledby={ariaLabelledBy}
      options={options}
      disabled={disabled}
      selectedValues={checkedValues}
      hasContainer={hasContainer}
      onClick={handleClick}
    />
  );
};
